import type { Animal } from './animal.interface';

export interface cv_AnimalClassification {
    Animal: Animal[];
    AnimalClassification: string;
    C_AnimalClassification_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
}
